import React, { useEffect,useCallback, useRef, useState } from "react";
import { createEditor, Transforms, Range, Editor } from 'slate';
import { Slate, Editable, withReact } from 'slate-react';
import EmojiPicker from "emoji-picker-react";
import { FaImages } from "react-icons/fa";
import { BiWorld } from "react-icons/bi";
import { FaUserGroup } from "react-icons/fa6";
import { styled } from "@mui/material/styles";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import Cookies from "js-cookie";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import BaseUrl from "../Components/BaseUrl";
import Swal from "sweetalert2";
import { MdOutlineAccessTime, MdOutlineCalendarToday, MdOutlineLocationOn } from "react-icons/md";
import {format, formatInTimeZone, toZonedTime } from 'date-fns-tz';
import { parse } from 'date-fns';

const ErrorDisplay = ({ errors }) => (
  <div className="space-y-2">
    {/* <h3 className="font-bold text-red-600 mb-2">Upload Issues</h3> */}
    {errors.map((error, i) => (
      <div key={i} className="bg-red-50 p-3 rounded border-l-4 border-red-500">
        <p className="font-base text-red-700">
          {error.fileName}: {error.title}
        </p>
        <p className="text-sm text-red-600 mt-1">
           {error.solution}
        </p>
      </div>
    ))}
  </div>
);

  const PostModal = ({ modalOpen, closeModal,eventData,onEventCreated }) => {
  const [postCaption, setPostCaption] = useState('');
  const [imageUploadModalOpen, setImageUploadModalOpen] = useState(false);
  const [tempImages, setTempImages] = useState([]);
  const [tempImagesFile, setTempImagesFile] = useState([]);
  const [uploadErrors, setUploadErrors] = useState([]);
  const [showErrorPanel, setShowErrorPanel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({});
  const [editor] = useState(() => withReact(createEditor()));
  const initialValue = [
    {
      type: "paragraph",
      children: [{ text: "" }],
    },
  ];
  const [content, setContent] = useState(initialValue);
  const [images, setImages] = useState([]);
  const [imagesFile, setImagesFile] = useState([]);
  const [isPostSettingOpen, setIsPostSettingOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("anyone");
  const [switchState, setSwitchState] = useState(false);
  const [commentControl, setCommentControl] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedCommentOption, setSelectedCommentOption] =
  useState("Connections only");
  const editableRef = useRef(null);

  const postsettingopenModal = () => {
    setIsPostSettingOpen(true);
  };
  const postsettingcloseModal = () => {
    setIsPostSettingOpen(false);
  };

  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: "#0B6623",
          opacity: 1,
          border: 0,
          ...theme.applyStyles("dark", {
            backgroundColor: "#2ECA45",
          }),
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: theme.palette.grey[100],
        ...theme.applyStyles("dark", {
          color: theme.palette.grey[600],
        }),
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.7,
        ...theme.applyStyles("dark", {
          opacity: 0.3,
        }),
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: "#E9E9EA",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
      ...theme.applyStyles("dark", {
        backgroundColor: "#39393D",
      }),
    },
  }));
  const BpIcon = styled("span")(({ theme }) => ({
    borderRadius: "16px",
    width: "100%",
    padding: "10px 10px",
    border: "5px solid #ccc",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s ease-in-out",
    backgroundColor: "#fff",
    cursor: "pointer",

    "input:hover ~ &": {
      border: "5px solid black",
    },

    "input:checked ~ &": {
      border: "5px solid #0B6623",
      backgroundColor: "#E8F0FE",
    },
  }));

  const BpCheckedIcon = styled(BpIcon)({
    // border: "2px solid #0B6623",
    boxShadow: "inset 0 0 0 2px #0B6623",
    backgroundColor: "#E8F0FE",
  });
  function BpRadio(props) {
    return (
      <Radio
        disableRipple
        color="default"
        checkedIcon={<BpCheckedIcon />}
        icon={<BpIcon />}
        {...props}
      />
    );
  }

  const handleradiochange = (e) => {
    setSelectedOption(e.target.value);
    console.log(e.target.value);
  };

  const getProfileData = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(BaseUrl + `users`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
        },
      });
      setData(response.data.data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getProfileData();
  }, []);

  useEffect(() => {
    if (selectedOption !== "anyone") {
      setSwitchState(false);
    }
  }, [selectedOption]);

  const handleSwitchChange = (event) => {
    setSwitchState(event.target.checked);
  };
  const handleCommentControl = (event) => {
    setSelectedCommentOption(event.target.value);
  };
  const handleChange = (value) => {
    setContent(value);
  };


  const ERROR_MAP = {
    DIMENSIONS: {
      title: "Low resolution",
      solution: `Minimum 800x450px required for clear display`,
    },
    SIZE: {
      title: "File too small",
      solution: `Minimum 100KB required for quality`,
    },
    FORMAT: {
      title: "Unsupported format",
      solution: "Use JPG, PNG or WebP",
    },
    LIMIT: {
      title: "Maximum exceeded",
      solution: "You can upload up to 10 images",
    },
  };


  const handleImageUploadTrigger = (event) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    setImageUploadModalOpen(true);
    processImages(files); 
    setTimeout(() => processImages(files), 0);
    event.target.value = ''; 
  };


  const processImages = async (files) => {
    const fileList = Array.from(files); 
    const validImages = [];
    const errors = [];
  
    const MIN_FILE_SIZE = 100*1024;
    const MIN_WIDTH = 600;
    const MIN_HEIGHT = 300;
    const MAX_IMAGES = 10;
  
    if (fileList.length + tempImages.length > MAX_IMAGES) {
      setUploadErrors([{
        title: "Too many images",
        solution: `You can upload maximum ${MAX_IMAGES} images total (currently ${tempImages.length})`,
        fileName: "Multiple files"
      }]);
      setShowErrorPanel(true);
      return;
    }
  
    for (const file of fileList) {
      try {
        
        if (file.size < MIN_FILE_SIZE) {
          console.log('filesize',file.name,file.size); 
          throw { code: "SIZE", file };
        }

        const dimensions = await getImageDimensions(file);
        if (dimensions.width < MIN_WIDTH || dimensions.height < MIN_HEIGHT) {
          throw { code: "DIMENSIONS", file };
        }
        validImages.push({
          preview: URL.createObjectURL(file),
          file,
          dimensions
        });
      } catch (error) {
        errors.push({
          ...ERROR_MAP[error.code],
          file: error.file,
          fileName: error.file?.name || "Unknown file"
        });
      }
    }
  
 
    if (errors.length > 0) {
      setUploadErrors(errors);
      setShowErrorPanel(true);
    
      // Create HTML content for better formatting
      const errorContent = errors
        .map(error => `
          <div style="text-align: left; margin-bottom: 15px;">
            <strong>${error.fileName}</strong><br>
            <span style="color: #dc3545;">Problem:</span> ${error.title}<br>
            <span style="color: #28a745;">Solution:</span> ${error.solution}
          </div>
        `)
        .join('<hr style="border: 1px solid #eee;">');
    
      Swal.fire({
        icon: 'error',
        title: 'Image Upload Issues',
        html: errorContent, 
        confirmButtonText: 'Ok',
        confirmButtonColor: '#007bff',
        showCancelButton: false,
        cancelButtonText: 'Ignore',
        cancelButtonColor: '#6c757d',
        width: '600px',
        customClass: {
          popup: 'user-friendly-swal',
          title: 'swal-title',
          htmlContainer: 'swal-content'
        },
        footer: '<a href="/upload-help">Need help with image uploads?</a>'
      }).then((result) => {
        if (result.isConfirmed) {

          console.log('User clicked Try Again');

        } else if (result.dismiss === Swal.DismissReason.cancel) {
          console.log('User chose to ignore errors');

        }
      });
    }
    if (validImages.length > 0) {
      setTempImages(prev => [...prev, ...validImages.map(img => img.preview)]);
      setTempImagesFile(prev => [...prev, ...validImages.map(img => img.file)]);

    }
  };

  const getImageDimensions = (file) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        resolve({
          width: img.naturalWidth,
          height: img.naturalHeight,
        });
      };
      img.src = URL.createObjectURL(file);
    });
  };
  const removeImage = (index) => {
    const updatedImages = images.filter((_, i) => i !== index);
    setImages(updatedImages);
  };



   
const ImageUploadModal = ( users) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [showFeedPreview, setShowFeedPreview] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [imageOrder, setImageOrder] = useState(tempImages.map((_, index) => index));
  const handleChange = (value) => {
    setContent(value);
  };

  const initialValue = [
    {
      type: "paragraph",
      children: [{ text: "" }],
    },
  ];
  const [content, setContent] = useState(initialValue);
  const [editor] = useState(() => withReact(createEditor()));
  

  const moveImage = (fromIndex, toIndex) => {
    const newOrder = [...imageOrder];
    const [removed] = newOrder.splice(fromIndex, 1);
    newOrder.splice(toIndex, 0, removed);
    setImageOrder(newOrder);
  };

  const handleEmojiClick = (emojiData) => {
    const { emoji } = emojiData;
    Transforms.insertText(editor, emoji);
    setShowEmojiPicker(false);
  };

  const getOrderedImages = () => {
    return imageOrder.map(index => tempImages[index]);
  };

  const renderElement = useCallback((props) => {
    const { attributes, children, element } = props;
    
    switch (element.type) {
      case 'mention':
        return <MentionElement {...props} />;
      case 'hashtag':
        return <HashtagElement {...props} />;
      default:
        return <p {...attributes}>{children}</p>;
    }
  }, []);


  const renderFeedPreview = () => {
    const imagesToPreview = getOrderedImages();
    
    return (
      <div className="bg-gray-100 p-4 rounded-lg">
        <div className="bg-white rounded-lg shadow-sm p-4">
          <div className="flex items-center mb-3">
            <div className="w-10 h-10 rounded-full bg-gray-300 mr-2"></div>
            <div>
              <div className="h-4 w-32 bg-gray-200 rounded mb-1"></div>
              <div className="h-3 w-24 bg-gray-100 rounded"></div>
            </div>
          </div>


          <div className="mb-3">
            {content.map((node, i) => (
              <div key={i} className="break-words whitespace-pre-wrap">
                {node.children.map((child, j) => (
                  <span key={j}>{child.text}</span>
                ))}
              </div>
            ))}
          </div>


          <div
            className={`grid gap-2 rounded-lg overflow-hidden ${
              imagesToPreview.length === 1
                ? "grid-cols-1 min-h-[250px]"
                : "grid-cols-2 min-h-[250px]"
            }`}
          >
            {imagesToPreview.slice(0, 4).map((image, index) => (
              <div
                key={index}
                className={`relative group cursor-pointer flex justify-center ${
                  imagesToPreview.length === 3 && index === 0
                    ? "col-span-2"
                    : ""
                }`}
              >
                <img
                  src={image}
                  alt={`preview-${index}`}
                  className="h-full w-full object-cover"
                />
                {index === 3 && imagesToPreview.length > 4 && (
                  <div className="absolute inset-0 flex items-center justify-center bg-black/40 text-white font-bold text-2xl">
                    +{imagesToPreview.length - 4}
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="mt-3 flex justify-between text-gray-500">
            <div className="flex space-x-4">
              <span className="cursor-pointer hover:text-blue-500">Like</span>
              <span className="cursor-pointer hover:text-blue-500">
                Comment
              </span>
              <span className="cursor-pointer hover:text-blue-500">Share</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-[90%] h-[90%] md:w-[80%] md:h-[80%] flex flex-col">
        <div className="flex justify-between items-center border-b border-gray-200 p-4">
          <h3 className="text-lg font-semibold">Create post</h3>
          <div className="flex space-x-4">
            <button
              onClick={() => setShowFeedPreview(!showFeedPreview)}
              className="px-3 py-1 bg-gray-100 rounded-md hover:bg-gray-200"
            >
              {showFeedPreview ? "Edit Images" : "Preview Post"}
            </button>
            <button
              onClick={() => setImageUploadModalOpen(false)}
              className="text-gray-500 hover:text-gray-700"
            >
              ×
            </button>
          </div>
        </div>
        <div className="flex-1 overflow-hidden flex flex-col md:flex-row">
          {!showFeedPreview ? (
            <div className="md:w-1/2 p-4 border-r border-gray-200 flex flex-col">
              <div className="flex-1 overflow-y-auto">
                <div className="grid grid-cols-3 gap-2">
                  {imageOrder.map((imgIndex, orderIndex) => (
                    <div
                      key={imgIndex}
                      className={`relative aspect-square border-2 rounded-lg overflow-hidden cursor-move ${
                        selectedIndex === orderIndex
                          ? "border-blue-500 ring-2 ring-blue-200"
                          : "border-gray-200"
                      }`}
                      draggable
                      onDragStart={(e) =>
                        e.dataTransfer.setData("text/plain", orderIndex)
                      }
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => {
                        e.preventDefault();
                        const fromIndex = parseInt(
                          e.dataTransfer.getData("text/plain")
                        );
                        moveImage(fromIndex, orderIndex);
                      }}
                      onClick={() => setSelectedIndex(orderIndex)}
                    >
                      <img
                        src={tempImages[imgIndex]}
                        alt={`Thumbnail ${imgIndex}`}
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute top-1 right-1 bg-white/90 rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold">
                        {orderIndex + 1}
                      </div>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          const newOrder = [...imageOrder];
                          newOrder.splice(orderIndex, 1);
                          setImageOrder(newOrder);
                          removeTempImage(imgIndex);
                        }}
                        className="absolute bottom-1 right-1 bg-white/90 text-gray-500 rounded-full w-5 h-5 flex items-center justify-center text-xs shadow-sm hover:bg-red-500 hover:text-white"
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              </div>
              <div className="mt-4">
                <button
                  onClick={() =>
                    document.querySelector('input[type="file"]').click()
                  }
                  className="w-full py-2 bg-blue-50 text-blue-600 rounded-md hover:bg-blue-100"
                >
                  + Add More Images
                </button>
              </div>
            </div>
          ) : (
            <div className="md:w-1/2 p-4 overflow-y-auto">
              {renderFeedPreview()}
            </div>
          )}

          <div className="md:w-1/2 p-4 flex flex-col">
            {!showFeedPreview ? (
              <>
                <h4 className="font-medium mb-2">Image {selectedIndex + 1}</h4>
                <div className="flex-1 flex items-center justify-center bg-gray-50 rounded-lg mb-4">
                <img
                    src={
                      tempImages[imageOrder[selectedIndex]] ||
                      "/Images/logo/Logo-2 1.png"
                    }
                    alt={`Selected ${selectedIndex}`}
                    className={`max-h-[300px] max-w-full object-contain transition-opacity duration-300 ${
                      tempImages[imageOrder[selectedIndex]] ? "" : "opacity-40"
                    }`}
                  />
                </div>
              </>
            ) : (
              // <div className="flex-1 flex flex-col">
              //   <h4 className="font-medium mb-3 text-lg">Post Details</h4>
              //   <div className="relative flex-1 mb-3 border rounded-lg p-3">
              //     <Slate
              //       editor={editor}
              //       initialValue={content}
              //       onChange={handleChange}
              //     >
              //       <Editable
              //         renderElement={renderElement}
              //         placeholder="What do you want to talk about?"
              //         ref={editableRef}
              //         className="  border border-white rounded-lg focus:outline-none focus:ring-2 focus:ring-white h-40"
              //       />
              //       <div className="flex space-x-2 mb-4">
              //         <button
              //           onClick={() => setShowEmojiPicker(!showEmojiPicker)}
              //           className="p-2 text-yellow-500 hover:bg-yellow-50 rounded"
              //           title="Add emoji"
              //         >
              //           😊
              //         </button>
              //       </div>
              //     </Slate>
              //     {showEmojiPicker && (
              //       <div className="mb-4">
              //         <EmojiPicker
              //           onEmojiClick={handleEmojiClick}
              //           width="100%"
              //           height={350}
              //           previewConfig={{ showPreview: false }}
              //         />
              //       </div>
              //     )}
              //   </div>

              //   <div className="flex justify-end space-x-2">
              //     <button
              //       onClick={() => setShowFeedPreview(false)}
              //       className="px-4 py-2 border rounded-md hover:bg-gray-50"
              //     >
              //       Back
              //     </button>
              //     <button
              //       onClick={() => {
              //         const orderedImages = getOrderedImages();
              //         const orderedFiles = imageOrder.map(
              //           (index) => tempImagesFile[index]
              //         );
              //         const captionText = content
              //           .map((node) =>
              //             node.children.map((child) => child.text).join("")
              //           )
              //           .join("\n");

              //         applyImages(orderedImages, orderedFiles, captionText);
              //       }}
              //       className={`px-4 py-2 rounded-md font-medium ${
              //         content.some((node) =>
              //           node.children.some((child) => child.text.trim() !== "")
              //         ) || tempImages.length > 0
              //           ? "bg-blue-600 text-white hover:bg-blue-700"
              //           : "bg-gray-300 text-gray-500 cursor-not-allowed"
              //       }`}
              //       disabled={
              //         !content.some((node) =>
              //           node.children.some((child) => child.text.trim() !== "")
              //         ) && tempImages.length === 0
              //       }
              //     >
              //       Done
              //     </button>
              //   </div>
              // </div>
              <div className="flex-1 flex flex-col">
                <h4 className="font-medium mb-3 text-lg">Post Details</h4>
                <div className="relative flex-1 mb-3 border rounded-lg p-3">
                  <Slate
                    editor={editor}
                    initialValue={content}
                    onChange={handleChange}
                  >
                    <Editable
                      renderElement={renderElement}
                      placeholder="What do you want to talk about?"
                      ref={editableRef}
                      className="border border-white rounded-lg focus:outline-none focus:ring-2 focus:ring-white h-40"
                    />
                  </Slate>
                </div>

                {/* Emoji button moved to bottom */}
                <div className="flex justify-start mb-3">
                  <button
                    onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                    className="p-2 text-yellow-500 hover:bg-yellow-50 rounded"
                    title="Add emoji"
                  >
                    😊
                  </button>
                </div>

                {/* Emoji picker as an absolute positioned element */}
                {showEmojiPicker && (
                  <div className="absolute z-10 bottom-16 left-0 w-full max-w-md">
                    <EmojiPicker
                      onEmojiClick={handleEmojiClick}
                      width="100%"
                      height={350}
                      previewConfig={{ showPreview: false }}
                    />
                  </div>
                )}

                <div className="flex justify-end space-x-2">
                  <button
                    onClick={() => setShowFeedPreview(false)}
                    className="px-4 py-2 border rounded-md hover:bg-gray-50"
                  >
                    Back
                  </button>
                  <button
                    onClick={() => {
                      const orderedImages = getOrderedImages();
                      const orderedFiles = imageOrder.map(
                        (index) => tempImagesFile[index]
                      );
                      const captionText = content
                        .map((node) =>
                          node.children.map((child) => child.text).join("")
                        )
                        .join("\n");

                      applyImages(orderedImages, orderedFiles, captionText);
                      setImageUploadModalOpen(false);
                    }}
                    className={`px-4 py-2 rounded-md font-medium ${
                      content.some((node) =>
                        node.children.some((child) => child.text.trim() !== "")
                      ) || tempImages.length > 0
                        ? "bg-blue-600 text-white hover:bg-blue-700"
                        : "bg-gray-300 text-gray-500 cursor-not-allowed"
                    }`}
                    disabled={
                      !content.some((node) =>
                        node.children.some((child) => child.text.trim() !== "")
                      ) && tempImages.length === 0
                    }
                  >
                    Done
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        <input
          type="file"
          accept="image/*"
          multiple
          className="hidden"
          onChange={(e) => {
            processImages(e.target.files);
            setImageOrder([
              ...imageOrder,
              ...Array(e.target.files.length)
                .fill()
                .map((_, i) => tempImages.length + i),
            ]);
          }}
        />
      </div>
    </div>
  );
};
  const applyImages = (orderedImages, orderedFiles, postCaption) => {
    setImages(orderedImages);
    setImagesFile(orderedFiles);   
    setImageUploadModalOpen(false);
    setPostCaption(postCaption);
    setTempImages([]);
    setTempImagesFile([]);
  };
  
  
  const removeTempImage = (index) => {
    const updatedImages = tempImages.filter((_, i) => i !== index);
    const updatedFiles = tempImagesFile.filter((_, i) => i !== index);
    setTempImages(updatedImages);
    setTempImagesFile(updatedFiles);
  };

  let eventTime = '';
  if (eventData) {
    const timeZone = eventData?.timezone || 'Asia/Calcutta';
    const startDateTimeStr = `${eventData.start_date}T${eventData.start_time}`;
    const startDate = new Date(startDateTimeStr);
    const zonedStartDate = toZonedTime(startDate, timeZone);

    const formattedDate = formatInTimeZone(zonedStartDate, timeZone, 'EEE, MMM d, yyyy');
    
    const formattedStartTime = formatInTimeZone(zonedStartDate, timeZone, 'h:mm a');
    
    let timeRange = formattedStartTime;
    if (eventData.is_endtime && eventData.end_time) {
      const endDateTimeStr = `${eventData.end_date}T${eventData.end_time}`;
      const endDate = new Date(endDateTimeStr);
      const zonedEndDate = toZonedTime(endDate, timeZone);
      const formattedEndTime = formatInTimeZone(zonedEndDate, timeZone, 'h:mm a');
      timeRange = `${formattedStartTime} - ${formattedEndTime}`;
    }

    const timezoneOffset = formatInTimeZone(zonedStartDate, timeZone, 'XXX');
    eventTime = `${formattedDate}, ${timeRange} (UTC ${timezoneOffset})`;
  }

  const handlepostformsubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append(
      "content",
      postCaption
    );
    imagesFile.forEach((file) => {
      formData.append("media_collection[]", file);
    });
    try {
      setIsSubmitting(true);
      const response = await axios.post(BaseUrl + "post", formData, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
        },
      });
      if (response.data.status === 200) {
        setImagesFile([]);
        setImages([]);
        setContent([]);
        closeModal();
        Swal.fire({
          icon: "success",
          title: "Post Created Successfully!",
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      }
    } catch (error) {
      console.log(error);
    }finally {
      setIsSubmitting(false);
    }
  };

  const handleEventPost = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    Object.keys(eventData).forEach((key) => {
      if (key === "speakers") {
        eventData.speakers.forEach((id) => formData.append("speakers[]", id));
      } else if (key === "image" && eventData.image) {
        formData.append(key, eventData.image);
      } else if (key === "is_endtime") {
        formData.append(key, eventData.is_endtime ? 1 : 0);
      } else {
        formData.append(key, eventData[key] || "");
      }
    });

    try {
      setIsSubmitting(true);
      const response = await axios.post(BaseUrl + "createEvent", formData, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
        },
      });
      if (response.data.status === 200) {
        const newEvent = response.data.data; 
        if (onEventCreated) {
          onEventCreated(newEvent); 
        }
        closeModal();;
        Swal.fire({
          icon: "success",
          title: "Event Created Successfully!",
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      }
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to create event post. Please try again.",
        confirmButtonText: "OK",
      });
    }
    finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {modalOpen && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <div className="modal-dialog bg-white rounded-[30px] shadow-lg max-w-3xl  w-full border-8 border-gray-500">
            <div className="modal-header bg-white  flex justify-between items-center rounded-[30px] px-4 py-2">
              <div
                className="flex items-start rounded-lg hover:bg-gray-200 p-2"
                onClick={() => {
                  postsettingopenModal();
                }}
              >
                <img
                  src={data.profile_image}
                  alt="User profile picture"
                  className="rounded-full w-12 h-12 mr-3"
                />
                <div className="flex-grow">
                  <div className="font-semibold text-lg text-black">
                    {data.name}
                  </div>
                  <div className="text-gray-500 text-[12px]">
                    {selectedOption}
                  </div>
                </div>
                <i className="fas fa-chevron-down text-gray-500 text-sm ml-2 mt-1"></i>
              </div>
              <button
                type="button"
                className="text-gray-500"
                onClick={closeModal}
              >
                ✖
              </button>
            </div>

            {isPostSettingOpen && (
              <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-10 ">
                <div className="bg-white shadow-lg rounded-[30px] w-full max-w-3xl mx-auto border-8 border-gray-500 ">
                  <div className="flex items-start rounded-lg px-5 py-4">
                    <div className="flex-grow">
                      <div className="font-semibold text-2xl">
                        Post settings
                      </div>
                    </div>
                    <button
                      onClick={postsettingcloseModal}
                      className="text-gray-500 hover:text-gray-700"
                    >
                      <i className="fas fa-times"></i>
                    </button>
                  </div>
                  <div className="max-h-[500px] overflow-y-auto border-y py-4 ">
                    <p className="px-5 ">Who can see your post?</p>
                    <div className="flex flex-col gap-2 py-4  ">
                      <div className="flex items-center justify-between hover:bg-gray-100 px-5 py-1 ">
                        <div className="flex items-center gap-4  ">
                          <div className=" text-3xl bg-gray-200 p-3 rounded-full">
                            <BiWorld />
                          </div>
                          <div>
                            <p>Anyone</p>
                            <p className="text-[12px] text-gray-500">
                              Anyone on or off LinkUP
                            </p>
                          </div>
                        </div>
                        <div>
                          <FormControl className="">
                            <RadioGroup
                              value={selectedOption}
                              onChange={handleradiochange}
                              aria-labelledby="demo-customized-radios"
                              name="customized-radios"
                            >
                              <FormControlLabel
                                value="anyone"
                                control={<BpRadio />}
                                className="MuiFormControlLabel-root w-full mb-2 p-3 hover:border-black transition"
                              />
                            </RadioGroup>
                          </FormControl>
                        </div>
                      </div>
                      <div className="flex items-center justify-between hover:bg-gray-100 px-5 py-1 ">
                        <div className="flex gap-4 items-center ">
                          <div className=" text-3xl bg-gray-200 p-3 rounded-full">
                            <FaUserGroup />
                          </div>
                          <div>
                            <p>Connections Only</p>
                          </div>
                        </div>
                        <div>
                          <FormControl className="">
                            <RadioGroup
                              value={selectedOption}
                              onChange={handleradiochange}
                              aria-labelledby="demo-customized-radios"
                              name="customized-radios"
                            >
                              <FormControlLabel
                                value="connections-only"
                                control={<BpRadio />}
                                className="MuiFormControlLabel-root w-full mb-2 p-3 hover:border-black transition"
                              />
                            </RadioGroup>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                    <div
                      onClick={() => {
                        setCommentControl(!commentControl);
                      }}
                      className="flex gap-4 items-center justify-between hover:bg-gray-100 px-8 py-4"
                    >
                      <div>
                        <p className="">Comment control</p>
                        <p className="text-md text-gray-500">
                          {selectedCommentOption}
                        </p>
                      </div>
                      <i
                        className={`fas ${
                          commentControl ? "fa-chevron-up" : "fa-chevron-down"
                        } text-gray-800 text-sm mr-8`}
                      ></i>
                    </div>
                    {commentControl && (
                      <div className=" flex flex-col  space-y-4 bg-gray-100 px-12 py-4">
                        <div className="flex items-center space-x-4">
                          <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
                            <i className="fas fa-globe text-xl text-gray-600"></i>
                          </div>
                          <span className="text-lg text-gray-800">Anyone</span>
                          <input
                            type="radio"
                            name="privacy"
                            value="Anyone"
                            className="ml-auto"
                            checked={selectedCommentOption === "Anyone"}
                            onChange={handleCommentControl}
                          />
                        </div>
                        <div className="flex items-center space-x-4">
                          <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
                            <i className="fas fa-users text-xl text-gray-600"></i>
                          </div>
                          <span className="text-lg text-gray-800">
                            Connections only
                          </span>
                          <input
                            type="radio"
                            name="privacy"
                            value="Connections only"
                            className="ml-auto"
                            checked={
                              selectedCommentOption === "Connections only"
                            }
                            onChange={handleCommentControl}
                          />
                        </div>
                        <div className="flex items-center space-x-4">
                          <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
                            <i className="fas fa-user-slash text-xl text-gray-600"></i>
                          </div>
                          <span className="text-lg text-gray-800">No one</span>
                          <input
                            type="radio"
                            name="privacy"
                            value="No one"
                            className="ml-auto"
                            checked={selectedCommentOption === "No one"}
                            onChange={handleCommentControl}
                          />
                        </div>
                      </div>
                    )}
                    <div
                      className="flex gap-4 items-center justify-between  px-8 py-4 "
                      style={{
                        cursor:
                          selectedOption !== "anyone"
                            ? "not-allowed"
                            : "default",
                      }}
                    >
                      <div>
                        <p
                          className={`${
                            selectedOption !== "anyone"
                              ? "text-gray-300"
                              : "text-black"
                          }`}
                        >
                          Brand partnership
                        </p>
                        <p
                          className={`${
                            selectedOption !== "anyone"
                              ? "text-gray-300"
                              : "text-gray-500"
                          } text-md `}
                        >
                          {switchState ? "on" : "off"}
                        </p>
                      </div>
                      <FormControlLabel
                        control={
                          <IOSSwitch
                            sx={{
                              m: 0,
                              cursor:
                                selectedOption !== "anyone"
                                  ? "not-allowed"
                                  : "pointer",
                            }}
                            checked={switchState}
                            onChange={handleSwitchChange}
                            disabled={selectedOption !== "anyone"}
                          />
                        }
                      />
                    </div>
                  </div>
                  <div className="flex justify-end space-x-2  py-4 px-5">
                    <button
                      className="bg-white text-blue-500 border border-blue-500 px-4 py-1 rounded-3xl"
                      onClick={() => {
                        setIsPostSettingOpen(false),
                          setSelectedOption("anyone"),
                          setSelectedCommentOption("Connections only");
                      }}
                    >
                      Back
                    </button>
                    <button
                      className="bg-blue-500 text-white px-4 py-1 rounded-3xl"
                      onClick={() => {
                        setIsPostSettingOpen(false);
                      }}
                    >
                      Done
                    </button>
                  </div>
                </div>
              </div>
            )}

            <div className=" modal-body py-4 px-6 overflow-y-auto max-h-[500px]">
              <div className="flex items-center">
                {eventData ? (
                  <div className="w-full bg-white rounded-lg shadow-md overflow-hidden border border-gray-200">
                    {eventData?.image && (
                      <div className="h-64 bg-gray-100 overflow-hidden">
                        <img
                          src={URL.createObjectURL(eventData.image)}
                          alt="Event cover"
                          className="w-full h-full object-cover"
                        />
                      </div>
                    )}
                    <div className="flex justify-between p-4 bg-white">
                      <div>
                        <p className="text-sm text-orange-600 font-semibold">
                          {eventTime}
                        </p>
                        <h2 className="text-lg font-bold text-gray-900 mt-1">
                          {eventData.event_name}
                        </h2>
                        <p className="text-sm text-gray-600">
                          Event by {data.name}
                        </p>
                        <p className="text-sm text-gray-600">
                          {eventData.event_type === "online"
                            ? eventData.event_type
                            : eventData.address}
                        </p>
                      </div>
                      <button className=" h-8 px-4 text-blue-600 border border-blue-600 rounded-full hover:bg-blue-100">
                        View event
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="bg-white rounded-lg shadow-sm p-4 w-3/4 ">
                    <div className="mb-3">
                      {postCaption && (
                        <p className="text-gray-600">{postCaption}</p>
                      )}
                    </div>
                    <div
                      className={`grid gap-2 rounded-lg overflow-hidden ${
                        images.length === 1
                          ? "grid-cols-1 min-h-[250px]"
                          : "grid-cols-2 min-h-[250px]"
                      }`}
                    >
                      {images.slice(0, 4).map((image, index) => (
                        <div
                          key={index}
                          className={`relative group cursor-pointer flex justify-center ${
                            images.length === 3 && index === 0
                              ? "col-span-2"
                              : ""
                          }`}
                        >
                          <img
                            src={image}
                            alt={`preview-${index}`}
                            className="h-full w-full object-cover"
                          />
                          {index === 3 && images.length > 4 && (
                            <div className="absolute inset-0 flex items-center justify-center bg-black/40 text-white font-bold text-2xl">
                              +{images.length - 4}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
              {!eventData ? (
                <div className="mt-2">
                  <label htmlFor="image-upload" className=" cursor-pointer">
                    <FaImages className="text-2xl text-gray-500" />
                  </label>

                  <input
                    id="image-upload"
                    type="file"
                    accept="image/*"
                    multiple
                    className="hidden"
                    onChange={handleImageUploadTrigger}
                  />
                </div>
              ) : (
                " "
              )}
            </div>

            {/* <div className="border-t">
              <div className="flex justify-end space-x-2  py-4 px-6">
                <div className="relative group">
                  <i className="far fa-clock text-2xl text-gray-500"></i>

                  <div className="absolute bottom-4 w-32 right-8 mt-8 ml-2 bg-white border rounded-lg shadow-lg p-2 text-sm text-gray-500 opacity-0 group-hover:opacity-100 transform scale-95 group-hover:scale-100 transition-all duration-200">
                    Schedule for later
                  </div>
                </div>
                <button
                  className="bg-blue-500 text-white px-4 py-1 rounded-2xl disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={eventData ? handleEventPost : handlepostformsubmit}
                >
                  Post
                </button>
              </div>
            </div> */}
            <div className="border-t">
              <div className="flex justify-end space-x-2 py-4 px-6">
                <div className="relative group">
                  <i className="far fa-clock text-2xl text-gray-500"></i>
                  <div className="absolute bottom-4 w-32 right-8 mt-8 ml-2 bg-white border rounded-lg shadow-lg p-2 text-sm text-gray-500 opacity-0 group-hover:opacity-100 transform scale-95 group-hover:scale-100 transition-all duration-200">
                    Schedule for later
                  </div>
                </div>
                <button
                  className="bg-blue-500 text-white px-4 py-1 rounded-2xl disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
                  onClick={eventData ? handleEventPost : handlepostformsubmit}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <svg
                        className="animate-spin h-5 w-5 mr-2 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="2"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8v8h8a8 8 0 01-16 0z"
                        ></path>
                      </svg>
                      Posting...
                    </>
                  ) : (
                    "Post"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {imageUploadModalOpen && <ImageUploadModal />}
    </>
  );
};

export default PostModal;
